import React from "react";
import PropTypes from "prop-types";
import { propOr, pathEq, filter } from "ramda";

import { MATERIAL_ITEM_TYPE } from "~/constants/dnd-types";
import { useDrop } from "react-dnd";
import { styled } from "@mui/material/styles";

import DragDropMaterial from "./DragDropMaterial";

const Layer = styled("div")(props => {
  return {
    height: `${props.marginalLayerHeight}px`,
    width: "100%"
  };
});

function MarginalLayerMaterials({ materials, page, marginalLayerHeight, onMaterialDrop, onMaterialClick }) {
  const [{}, dropTarget] = useDrop({
    accept: MATERIAL_ITEM_TYPE,
    drop: onMaterialDrop
  });

  const getMaterialsByPage = propOr([], page, materials);
  const isMarginalMaterial = pathEq(["position", "marginal"], true);
  const filtered = filter(isMarginalMaterial, getMaterialsByPage);

  function renderMaterial(material) {
    if (material.noMarker) return null;
    return (
      <DragDropMaterial
        {...material}
        _id={material._id}
        _rev={material._rev}
        key={`${material._id}_${material.position._id}`}
        clickHandler={onMaterialClick(material)}
      />
    );
  }

  return (
    <Layer ref={dropTarget} marginalLayerHeight={marginalLayerHeight}>
      {filtered.map(renderMaterial)}
    </Layer>
  );
}

MarginalLayerMaterials.propTypes = {
  page: PropTypes.number.isRequired,
  materials: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  marginalLayerHeight: PropTypes.number.isRequired,
  onMaterialDrop: PropTypes.func.isRequired,
  onMaterialClick: PropTypes.func.isRequired
};

export default MarginalLayerMaterials;
